import { render, staticRenderFns } from "./folder-list-item.vue?vue&type=template&id=6aa7c979"
import script from "./folder-list-item.vue?vue&type=script&lang=js"
export * from "./folder-list-item.vue?vue&type=script&lang=js"
import style0 from "./folder-list-item.vue?vue&type=style&index=0&id=6aa7c979&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports